<template>
  <b-container class="incomeFromSaleWrapper">
    <b-card class="mt-1 mb-1">
      <!-- DOC NUMBER, SENDER NAME -->
      <div class="text-center d-flex justify-content-around align-items-center mb-1">
        <!-- GO BACK BUTTON -->
        <b-link
          @click="goBackToFrom"
          variant="outline-dark"
          v-b-tooltip.hover
          :title="$t('back')"
          style="font-size: 17px;"
        >
          <i class="fa fa-arrow-left"></i>
        </b-link>
        <h4 class="font-weight-bold text-uppercase mb-0">
          {{ $t('prices.item.docNumber') }}:
          <span
            class="small"
          >{{ currentPendingIncomeFromSale.saleNumber }}</span>
        </h4>
        <p class="mb-0">
          <strong>{{ $t('incomes.senderName') }}:&nbsp;</strong>
          <span>{{ currentPendingIncomeFromSale.senderName }}</span>
        </p>
        <p class="mb-0">
          <strong>{{ $t('incomes.senderDepartment') }}:&nbsp;</strong>
          <span>{{ currentPendingIncomeFromSale.departmentName }} ({{currentPendingIncomeFromSale.departmentAddress }})</span>
        </p>
      </div>

      <div id="tableTopActions" class="d-flex justify-content-between align-items-center mb-2">
        <!-- TOP LEFT BUTTONS -->
        <div id="topLeftButtons">
          <b-container id="showIfNotFoundItems" v-if="thereNotFoundItems">
            <b-row>
              <b-col cols="12" class="text-right">
                <b-checkbox
                  @change="setFromCheckbox(true)"
                  v-model="checkAllNotFounds"
                  style="display: inline-block; margin-right: 20px;"
                >{{ $t('incomes.addAllItems') }}</b-checkbox>
                <b-button
                  @click="openNotFoundItemsConfirm"
                  :disabled="newItemsToCreate.length < 1"
                  variant="info"
                  class="ml-2"
                >{{ $t('incomes.add') }}</b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
          <b-col cols="6" v-if="currentPendingIncomeFromSale.status == 'STANDALONE'">
             <div class="alert alert-warning p-2 mt-1 text-center"
             style="font-size: 20px" role="alert">
            Aвтономный режим включен
          </div>
          </b-col>

        <!-- TOP RIGHT BUTTONS -->
        <div id="topRightButtons" class="d-flex align-items-center">
          <!-- FOUND/NOTFOUND BARCODES -->
          <template v-if="isBarcode">
            <div id="notFoundBarcode" class="mr-4" v-if="barcodeNotFound">
              <span>
                <strong>{{ currentBarcode }}</strong> - товар не найден
              </span>
            </div>
            <div id="lastFoundBarcode" class="mr-4" v-if="barcodeFound">
              <span>
                <strong>{{ currentBarcode }}</strong> - товар добавлен
              </span>
            </div>
            <div id="fullyAcceptedBarcode" class="mr-4 text-warning" v-if="barcodeFullyAccepted">
              <span>
                <strong>{{ currentBarcode }}</strong> - товар уже полностью принят
              </span>
            </div>
          </template>
          <div>
            <b-form-group class="pull-right mb-0">
              <b-form-radio-group
                :disabled="currentPendingIncomeFromSale.status == 'STANDALONE'"
                id="btn-radios-2"
                v-model="countType"
                :options="types"
                buttons
                button-variant="outline-primary"
                size="sm"
                name="radio-btn-outline"
              ></b-form-radio-group>
            </b-form-group>
            <div class="clearfix"></div>
          </div>
          <div class="actions">
            <b-container>
              <b-row>
                <b-col cols="12" class="text-right">
                  <b-checkbox
                    :disabled="currentPendingIncomeFromSale.status == 'STANDALONE'"
                    v-model="fillAllItems"
                    style="display: inline-block; margin-right: 20px; cursor: pointer"
                  >{{ $t('incomes.checkAll') }}</b-checkbox>
                  <b-button
                    :disabled="currentPendingIncomeFromSale.status == 'STANDALONE'"
                    @click="openDepSelectModal"
                    variant="success"
                    class="ml-2"
                  >{{ $t('pending.save') }}</b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
      <!-- DOCUMENT ITEMS TABLE -->
      <b-table-new
        v-if="!loading"
        :fields="columns"
        :items="accepted"
        class="verticalAlignMiddle pendingIncomeFromSaleTable"
        striped
        sticky-header="565px"
      >
        <!-- CUSTOM ROW IN HEADER FOR TOTAL AMOUNTS -->
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="8">
              <p class="mr-2" style="text-align: right; font-size: 14px;">
                <strong>Итого</strong>
              </p>
            </b-th>
            <b-th
              variant="secondary"
              class="textAlignCenter"
            >{{ calculateTotalLeftCount() | currency({symbol: '', symbolPosition: 'back'}) }}</b-th>
            <b-th
              variant="primary"
              class="textAlignCenter"
            >{{ calculateTotalLeftSum() | currency({symbol: '', symbolPosition: 'back'}) }}</b-th>
            <b-th
              variant="success"
              class="textAlignCenter"
            >{{ calculateTotalReceivingCount() | currency({symbol: '', symbolPosition: 'back'}) }}</b-th>
          </b-tr>
        </template>

        <template v-slot:cell(id)="data">
          <b-checkbox
            v-model="newItemsToCreate"
            @change="notFoundItemChecked($event, data.item)"
            v-if="data.item['_rowVariant'] == 'danger'"
            :value="data.item"
            size="sm"
            style="display: inline-block"
          ></b-checkbox>
          <strong>{{ data.index + 1}}</strong>
        </template>

        <template v-slot:cell(name)="data">{{ data.item.name.substring(0, 81) }}</template>

        <template v-slot:cell(count)="data">{{ leftCountForItem(data.item) }}</template>

        <template v-slot:cell(barcode)="data">
          <span
            :style="[data.item.wrapped ? {'font-weight': 'bold', 'color': 'blue'} : {}]"
          >{{ data.item.barcode }}</span>
        </template>

        <template v-slot:cell(artikul)="data">
          <span
            :style="[data.item.wrapped ? {'font-weight': 'bold', 'color': 'blue'} : {}]"
          >{{ data.item.artikul }}</span>
        </template>

        <template
          v-slot:cell(priceAfterUzs)="data"
        >{{ data.item.priceAfterUzs | currency({symbol: '', symbolPosition: 'back'}) }}</template>

        <template
          v-slot:cell(eachTotalPrice)="data"
        >{{ totalLeftPriceForItem(data.item) | currency({symbol: '', symbolPosition: 'back'}) }}</template>

        <template v-slot:cell(receivingCount)="data">
          <span v-if="accepted.length > 0" class="w-10p text-center" style="font-size: 13px">
            <span
              class="text-danger"
              v-if="accepted[data.index].changed && (checkIsKam(data.index) || checkIsKop(data.index))"
            >
              <i class="fa fa-question-circle"></i>
            </span>
            <span
              class="text-success"
              v-if="accepted[data.index].changed && checkIsTeng(data.index)"
            >
              <i class="fa fa-check"></i>
            </span>
          </span>
          <div class="w-88p receiveInput" >
            <!-- IF ACCEPTED ARRAY IS READY -->
            <b-input-group v-if="accepted[data.index]" size="sm">
              <b-input
                type="number"
                @keyup="keyup(data.index)"
                :disabled="isBarcode || data.item['_rowVariant'] == 'success' ||
                currentPendingIncomeFromSale.status == 'STANDALONE'"
                @focus="$event.target.select()"
                @input="receivingCountEntered($event, data.index)"
                :value="accepted[data.index].currentReceivingCount"
                min="0"
                size="sm"
                style="height: 20px; padding: 3px 3px 3px 5px; font-size: 12px"
              ></b-input>
              <b-input-group-addon style="z-index: 1; height: 20px">
                <b-button
                  disabled
                  size="sm"
                  style="font-size: 11px; padding: 2px 10px 10px"
                  :style="[data.item.wrapped ? {'font-weight': 'bold', 'color': 'blue'} : {'font-weight': 'bold'}]"
                >{{data.item.wrapped ? $t('sack') : $t('piece')}}</b-button>
              </b-input-group-addon>
            </b-input-group>
            <!-- IF ACCEPTED ARRAY IS NOT READY YET -->
            <b-input v-else type="number" disabled></b-input>
          </div>
        </template>
      </b-table-new>
      <div v-if="loading" class="spinner-wrapper">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </b-card>

    <!-- ADD NOT FOUND ITEMS CONFIM MODAL -->
    <b-modal v-model="addItemsModal" @ok="addNotFoundItems()" ok-title="Да" cancel-title="Отмена">
      <h4>Хотите добавить эти товары в свою базу?</h4>
    </b-modal>

    <!-- DEPARTMENT SELECT MODAL FOR SALDO BEGIN  -->
    <b-modal ref="receiveDepSelectModal" hide-footer ok-title="Save">
      <div slot="modal-header" class="posCustomModalHeader d-flex justify-content-between">
        <h5 slot="modal-title" class="mb-0">Пожалуйста, выберите отдел</h5>
        <!-- SMALL LOADER -->
        <b-spinner v-if="loading" small class="ml-2" variant="primary" label="Small Spinner"></b-spinner>
        <!-- SMALL LOADER -->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="closeDepSelectModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>

      <b-alert
        v-if="pendingIncomeFromSaleError.boolean"
        :show="dismissCountDown"
        dismissible
        style="margin-bottom: 10px;"
        variant="warning"
        size="sm"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <p>{{ pendingIncomeFromSaleError.message }}</p>
      </b-alert>
      <div>
        <b-row>
          <b-col sm="6">
            <label for="receiveIncomeDepartmentSelect">
              <span style="color: red;">*</span>
              {{$t('pricing.department')}}
            </label>
            <multiselect
              :options="myDepartments"
              :multiple="false"
              v-model="departmentForIncome"
              track-by="id"
              label="name"
              id="receiveIncomeDepartmentSelect"
              :show-labels="false"
              :placeholder="$t('promo-to-product.department')"
              :allow-empty="false"
              class="departmentForContragent"
            >
              <template v-slot:cell(option)="data">
                {{ option.option.name
                }} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency'
                }})
              </template>
            </multiselect>
          </b-col>
        </b-row>
      </div>
      <div class="model-actions">
        <b-row class="align-items-center">
          <b-col cols="12" class="mb-3 mb-xl-0">
            <b-row class="d-flex justify-content-end">
              <b-col cols="4">
                <b-button
                  block
                  size="sm"
                  type="button"
                  @click="closeDepSelectModal"
                  variant="outline-danger"
                >
                  {{
                  $t('actions.cancel') }}
                </b-button>
              </b-col>
              <b-col cols="4">
                <b-button
                  block
                  type="button"
                  size="sm"
                  :disabled="receiveDisabled"
                  @click="checkAndSave"
                  variant="primary"
                >{{ $t('pending.save') }}</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- DEPARTMENT SELECT MODAL FOR PENDING INCOME  -->
  </b-container>
</template>

<script>
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import { mapActions, mapState, mapGetters } from 'vuex';
import { errorAndSuccessSounds } from '../../../../../mixins/errorAndSuccessSounds';
import { BTable, BTr, BTh, BThead } from 'bootstrapVue2';

export default {
  name: 'PendingIncomeFromSale',
  mixins: [errorAndSuccessSounds],
  components: {
	Multiselect,
	'b-table-new': BTable,
	BTr,
	BTh,
	BThead
  },
  data() {
    return {
      fullyAcceptedItems: [],
      originalFilteredItems: [],
      fromCheckbox: false,
      addItemsModal: false,
      newItemsToCreate: [],
      barcodeFullyAccepted: false,
      checkAllNotFounds: false,
      barcodeFound: null,
      barcodeNotFound: null,
      currentBarcode: '',
      hasMinusValue: false,
      emptyReceivingCount: true,
      receiveDisabled: false,
      fillAllItems: false,
      departmentForIncome: null,
      /* DATA FOR ALERT  */
      dismissCountDown: 4,
      /* DATA FOR ALERT  */
      accepted: [],
      countType: 'Ручной',
      types: ['Штрихкод', 'Ручной'],
      hasShortage: false,
      moreCount: false
    };
  },
  /**
   * METHODS
   */
  methods: {
    ...mapActions('departments', ['fetchMyDepartments']),
    ...mapActions('warehouse', ['getWhDocById', 'createWhDoc']),
    ...mapActions('whIncomeModule', [
      'fetchPendingIncomeFromSaleById',
      'receivePendingIncomeFromSale',
      'addNotFoundItemsToDatabase'
    ]),
    totalLeftPriceForItem(item) {
      return item.priceAfterUzs * this.leftCountForItem(item);
    },
    leftCountForItem(item) {
      return (
        parseFloat(item.count) -
        (item.receiveCount ? parseFloat(item.receiveCount) : 0)
      );
    },
    calculateTotalLeftCount() {
      let resultNumber = 0;
      let lengthForLoop = this.accepted.length;
      for (let i = 0; i < lengthForLoop; i++) {
        resultNumber += this.leftCountForItem(this.accepted[i]);
      }
      return resultNumber;
    },
    calculateTotalLeftSum() {
      let totalLeftSum = 0;
      let lengthForLoop = this.accepted.length;
      for (let i = 0; i < lengthForLoop; i++) {
        totalLeftSum += this.totalLeftPriceForItem(this.accepted[i]);
      }
      return totalLeftSum;
    },
    calculateTotalReceivingCount() {
      let totalReceivingCount = 0;
      let lengthForLoop = this.accepted.length;
      for (let i = 0; i < lengthForLoop; i++) {
        if (
          this.accepted[i].currentReceivingCount &&
          this.accepted[i].currentReceivingCount !== ''
        ) {
          totalReceivingCount += parseFloat(
            this.accepted[i].currentReceivingCount
          );
        }
      }
      return totalReceivingCount;
    },
    // THIS IS FOR NOT FOUND ITEMS CHECKBOX
    setFromCheckbox(boolean) {
      this.fromCheckbox = boolean;
    },
    numberOfNotFoundItems() {
      let count = 0;
      let length = this.accepted.length;
      for (let i = 0; i < length; i++) {
        if (this.accepted[i].hasOwnProperty('_rowVariant')) {
          if (this.accepted[i]['_rowVariant'] == 'danger') {
            count++;
          }
        }
      }
      return count;
    },
    async addNotFoundItems() {
      await this.addNotFoundItemsToDatabase(this.newItemsToCreate);
      if (this.pendingIncomeFromSaleError.boolean) {
        this.$vs.notify({
          title: `${this.pendingIncomeFromSaleError.message}`,
          time: 5000,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        });
      } else {
        let length = this.newItemsToCreate.length;
        for (let i = 0; i < length; i++) {
          let foundIndex = this.accepted.indexOf(this.newItemsToCreate[i]);
          if (foundIndex > -1) {
            if (this.accepted[foundIndex].hasOwnProperty('_rowVariant')) {
              delete this.accepted[foundIndex]['_rowVariant'];
              Vue.set(this.accepted, foundIndex, this.accepted[foundIndex]);
            }
          }
        }
        this.$vs.notify({
          title: `Товары успешно добавлены`,
          time: 3000,
          color: 'success',
          icon: 'close',
          position: 'top-right'
        });
      }
    },
    notFoundItemChecked(event, item) {
      if (event) {
        this.newItemsToCreate.push(item);
        if (this.newItemsToCreate.length == this.numberOfNotFoundItems()) {
          this.checkAllNotFounds = true;
          //   FROM CHECKBOX NI FALSE QILISH KERAK CHUNKI 'checkAllNotFounds' CHECKBOXDAN BOSHQA JOYDA O'ZGARTIRILYAPTI
          this.setFromCheckbox(false);
        }
      } else {
        const indexInArray = this.newItemsToCreate.indexOf(item);
        if (indexInArray > -1) {
          this.newItemsToCreate.splice(indexInArray, 1);
        }
        if (this.newItemsToCreate.length !== this.numberOfNotFoundItems()) {
          this.checkAllNotFounds = false;
          //   FROM CHECKBOX NI FALSE QILISH KERAK BO'LMASA HAMMA TOVAR UNCHECKED BO'LIB QOLADI
          this.setFromCheckbox(false);
        }
      }
    },
    checkFullyAcceptedItems() {
      this.accepted.map((item, index) => {
		if(item.currentReceivingCount) {
			item.currentReceivingCount = null;
		}
        if (item.receiveCount) {
          if (item.count == item.receiveCount) {
            // IF ITEM WAS FULLY ACCEPTED, SET _ROWVARIANT SUCCESS
            Vue.set(item, '_rowVariant', 'success');
            Vue.set(this.accepted, index, item);
          }
        }
        return item;
      });
      /* THIS IS JUST TO TRIGGER WATCHER */
      Vue.set(this.accepted, 0, this.accepted[0]);
      /* THIS IS TO REMOVE FULLY ACCEPTED ITEMS FROM LIST AND COLLECT THEM TO ANOTHER LIST */
      this.accepted = this.accepted.filter(el => {
        if (el.hasOwnProperty('_rowVariant')) {
          if (el['_rowVariant'] !== 'success') {
            return el;
          } else {
            this.fullyAcceptedItems.push(el);
          }
        } else {
          return el;
        }
      });
      //   SAVE ARRAY TO ANOTHER VARIABLE TO CHECK RECEIVING_COUNT DIFFERENCES
      this.originalFilteredItems = JSON.stringify(this.accepted.slice());
      this.originalFilteredItems = JSON.parse(this.originalFilteredItems);
    },
    openNotFoundItemsConfirm() {
      this.addItemsModal = true;
    },
    checkIfDocIsAccepted() {
      if (this.currentPendingIncomeFromSale.status == 'ACCEPTED') {
        this.$router.push(`/warehouse-management/income`);
      }
    },
    removeRowVariantFromItems() {
      let length = this.accepted.length;
      for (let i = 0; i < length; i++) {
        if (
          this.accepted[i].hasOwnProperty('_rowVariant') &&
          this.accepted[i]['_rowVariant'] != 'success'
        ) {
          delete this.accepted[i]['_rowVariant'];
        }
      }
    },
    setCellVariantsForItem(index) {
      if (this.accepted[index].hasOwnProperty('_rowVariant')) {
        delete this.accepted[index]['_rowVariant'];
      }
      Vue.set(this.accepted[index], '_cellVariants', {
        barcode: 'warning',
        receivingCount: 'warning',
        name: 'warning',
        id: 'warning'
      });
    },
    removeCellVariantsFromItem(index) {
      if (this.accepted[index].hasOwnProperty('_cellVariants')) {
        delete this.accepted[index]['_cellVariants'];
      }
    },
    makeReceivePayload() {
	  let payload = {};
      payload = Object.assign({}, this.currentPendingIncomeFromSale);
      if (payload) {
        payload.saleItemDtos = this.accepted.map(el => {
          if (el.receiveCount) {
            if (el.currentReceivingCount && el.currentReceivingCount !== '') {
              if (parseFloat(el.currentReceivingCount) > 0) {
                el.receiveCount =
                  parseFloat(el.receiveCount) +
                  parseFloat(el.currentReceivingCount);
              }
            }
          } else {
            if (el.currentReceivingCount && el.currentReceivingCount !== '') {
              if (parseFloat(el.currentReceivingCount) > 0) {
                Vue.set(
                  el,
                  'receiveCount',
                  parseFloat(el.currentReceivingCount)
                );
              }
            }
          }
          if (el.hasOwnProperty('_rowVariant')) {
            delete el['_rowVariant'];
          }
          return el;
        });
        payload.saleItemDtos = [
          ...payload.saleItemDtos,
          ...this.fullyAcceptedItems
		];
        payload.saleItems = JSON.stringify(payload.saleItemDtos);
        if (Array.isArray(payload.payments)) {
          payload.paymentDtos = payload.payments;
          payload.payments = JSON.stringify(payload.payments);
        } else if (payload.payments) {
          payload.paymentDtos = JSON.parse(payload.payments);
        }
      }
      return payload;
    },
    receivingCountEntered(event, index) {
      Vue.set(this.accepted[index], 'currentReceivingCount', event);
      Vue.set(this.accepted, index, this.accepted[index]);
    },
    async openDepSelectModal() {
      this.hasShortage = false;
      this.moreCount = false;
      this.hasMinusValue = false;
      await this.checkShortage();
      if (this.moreCount || this.emptyReceivingCount || this.hasMinusValue) {
        this.playErrorSound();
        this.$vs.notify({
          title: 'Неверное количество товаров!',
          color: 'warning',
          icon: 'close',
          position: 'top-right'
        });
        return 0;
      }
      if (this.myDepartments.length == 0) {
        this.fetchMyDepartments();
      }
      this.$refs.receiveDepSelectModal.show();
    },

    closeDepSelectModal() {
      this.$refs.receiveDepSelectModal.hide();
    },

    goBackToFrom() {
      this.$router.back();
    },

    countDownChanged(dismissCountDown) {
      if (dismissCountDown <= 1) {
        dismissCountDown = 3;
      }
      this.dismissCountDown = dismissCountDown;
    },
    /**
     *
     * @returns {*}
     */

    async get() {
      if (this.currentPendingItems !== undefined) {
        this.accepted = JSON.stringify(this.currentPendingItems.slice());
        this.accepted = JSON.parse(this.accepted).map(this.resetChanged);
        this.accepted.map(item => {
          return item;
        });

        this.checkFullyAcceptedItems();
      }
    },
    /**
     *
     */
    keyup(index) {
      this.accepted[index].changed = true;
    },

    /**
     *
     * @param item
     * @returns {*}
     */

    resetChanged(item) {
      item.changed = false;
      // item.count = 0;
      return item;
    },
    /**
     *
     * @param barcode
     */
    onBarcodeScanned(barcode) {
      if (this.isBarcode) {
        this.currentBarcode = barcode;

        const item = this.findItemByBarcode(barcode);
        if (item) {
          if (item['_rowVariant'] == 'success') {
            this.$vs.notify({
              title: `${barcode} - товар уже полностью принят`,
              time: 6000,
              color: 'warning',
              icon: 'close',
              position: 'top-right'
            });
            this.playErrorSound();
            this.barcodeFullyAccepted = true;
            this.barcodeFound = false;
            this.barcodeNotFound = false;
            return 0;
          }
          let index = this.accepted.indexOf(item);
          Vue.set(
            this.accepted[index],
            'currentReceivingCount',
            this.accepted[index].currentReceivingCount
              ? parseFloat(this.accepted[index].currentReceivingCount) + 1
              : 1
          );
          this.removeRowVariantFromItems();
          this.playSuccessSound();
          this.$vs.notify({
            title: `${barcode} - товар добавлен`,
            time: 3000,
            color: 'success',
            icon: 'close',
            position: 'top-right'
          });
          Vue.set(this.accepted[index], '_rowVariant', 'info');
          Vue.set(this.accepted, index, this.accepted[index]);
          this.accepted[index].changed = true;
          this.barcodeNotFound = false;
          this.barcodeFound = true;
          this.barcodeFullyAccepted = false;
        } else {
          this.removeRowVariantFromItems();
          this.barcodeNotFound = true;
          this.barcodeFound = false;
          this.barcodeFullyAccepted = false;
          this.playErrorSound();
          this.$vs.notify({
            title: `${barcode} - товар не найден`,
            time: 6000,
            color: 'danger',
            icon: 'close',
            position: 'top-right'
          });
        }
      }
    },

    /**
     *
     * @param response
     */
    findItemByBarcode(barcode) {
      return this.accepted.find(item => {
        if (item.barcode === barcode) {
          return item;
        }
      });
    },

    /**
     *
     */
    checkIsKam(index) {
      return (
        parseFloat(this.originalFilteredItems[index].count) -
          (this.originalFilteredItems[index].receiveCount
            ? parseFloat(this.originalFilteredItems[index].receiveCount)
            : 0) >
        parseFloat(this.accepted[index].currentReceivingCount)
      );
    },

    /**
     *
     */
    checkIsKop(index) {
      let isKop =
        parseFloat(this.originalFilteredItems[index].count) -
          (this.originalFilteredItems[index].receiveCount
            ? parseFloat(this.originalFilteredItems[index].receiveCount)
            : 0) <
        parseFloat(this.accepted[index].currentReceivingCount);
      if (!isKop) {
        this.removeCellVariantsFromItem(index);
      }
      return isKop;
    },

    checkIsTeng(index) {
      return (
        parseFloat(this.originalFilteredItems[index].count) -
          (this.originalFilteredItems[index].receiveCount
            ? parseFloat(this.originalFilteredItems[index].receiveCount)
            : 0) ===
        parseFloat(this.accepted[index].currentReceivingCount)
      );
    },

    async checkAndSave() {
      if (this.departmentForIncome) {
        let temp = {
          depId: this.departmentForIncome.id,
          payload: this.makeReceivePayload()
        };

        this.receiveDisabled = true;
        await this.receivePendingIncomeFromSale(temp);
        this.receiveDisabled = false;
        if (this.responseFromReceive.status) {
          // REDIRECT TO SHOW_INCOME_DOC PAGE
          this.$router.push(
            `/warehouse-management/income/view/${this.responseFromReceive.document.id}`
          );
        } else {
          if (!this.pendingIncomeFromSaleError.boolean) {
            this.accepted = JSON.stringify(this.currentPendingItems.slice());
            this.accepted = JSON.parse(this.accepted);
            this.checkFullyAcceptedItems();
            this.closeDepSelectModal();
            this.$vs.notify({
              title: 'Есть новых товаров, которых нет в вашей базе',
              time: 3000,
              color: 'warning',
              icon: 'close',
              position: 'top-right'
            });
          } else {
            this.dismissCountDown = 4;
          }
        }
      } else {
        this.playErrorSound();
        this.$vs.notify({
          title: 'Пожалуйста выберите Отдел',
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        });
        return 0;
      }
    },

    /**
     * Check shortages
     */
    checkShortage() {
      this.emptyReceivingCount = true;
      this.accepted.map((item, index) => {
        item.changed = true;
        if (
          parseFloat(item.currentReceivingCount) >
          parseFloat(
            this.originalFilteredItems[index].count -
              (this.originalFilteredItems[index].receiveCount
                ? this.originalFilteredItems[index].receiveCount
                : 0)
          )
        ) {
          this.moreCount = true;
          this.setCellVariantsForItem(index);
          Vue.set(this.accepted, index, this.accepted[index]);
        }
        if (
          parseFloat(item.currentReceivingCount) !==
          parseFloat(
            this.originalFilteredItems[index].count -
              (this.originalFilteredItems[index].receiveCount
                ? this.originalFilteredItems[index].receiveCount
                : 0)
          )
        ) {
          this.hasShortage = true;
        }
        if (item.currentReceivingCount !== '' && item.currentReceivingCount) {
          this.emptyReceivingCount = false;
          if (parseFloat(item.currentReceivingCount) < 0) {
            this.setCellVariantsForItem(index);
            Vue.set(this.accepted, index, this.accepted[index]);
            this.hasMinusValue = true;
          }
        }
      });
    },

    /**
     * Shortage
     */
    async shortage() {
      let temp = this.accepted.filter(item => {
        if (item.currentReceivingCount > 0) {
          return item;
        }
      });
      await this.checkPendingIncomeItems(temp);
      await this.receivePendingIncome(temp);
      await this.acceptByManufacturer(this.makeReceivePayload());
    }
  },

  computed: {
    ...mapGetters('departments', ['myDepartments']),
    ...mapState('whIncomeModule', [
      'packListItems',
      'currentPackDocId',
      'currentPendingItems',
      'currentPendingIncomeFromSale',
      'pendingIncomeFromSaleError',
      'newDocument',
      'loading',
      'responseFromReceive'
    ]),
    /**
     * checkForNotFoundItems
     * @returns {boolean}
     */
    thereNotFoundItems() {
      let boolean = false;
      let itemsLength = this.accepted.length;
      for (let i = 0; i < itemsLength; i++) {
        if (
          this.accepted[i].hasOwnProperty('_rowVariant') &&
          this.accepted[i]['_rowVariant'] == 'danger'
        ) {
          boolean = true;
        }
      }
      return boolean;
    },
    columns() {
      return [
        {
          key: 'id',
          label: '№',
          class: 'textAlignCenter'
        },
        {
          key: 'barcode',
          label: this.$t('goods.barcode'),
          sortable: true,
          class: 'textAlignCenter width11_wordBreak'
        },
        {
          key: 'name',
          label: this.$t('goods.name'),
          sortable: true,
          class: 'textAlignCenter width21_wordBreak'
        },
        {
          key: 'brandName',
          label: this.$t('goods.brand'),
          sortable: true,
          class: 'textAlignCenter'
        },
        {
          key: 'artikul',
          label: this.$t('goods.artikul'),
          sortable: true,
          class: 'textAlignCenter'
        },
        {
          key: 'colorName',
          label: this.$t('goods.color'),
          sortable: true,
          class: 'textAlignCenter'
        },
        {
          key: 'size',
          label: this.$t('goods.size'),
          sortable: true,
          class: 'textAlignCenter'
        },
        {
          key: 'priceAfterUzs',
          label: this.$t('incomes.create.price'),
          class: 'td-30 textAlignCenter',
          sortable: true,
          changebale: true
        },
        {
          key: 'count',
          label: this.$t('sale.kol-vo'),
          changebale: false,
          class: 'w-300 textAlignCenter',
          sortable: true,
          width: '18%'
        },
        {
          key: 'eachTotalPrice',
          label: this.$t('total-amount'),
          class: 'td-30 textAlignCenter',
          sortable: true,
          changebale: true
        },
        {
          key: 'receivingCount',
          label: 'Принимающее кол-во',
          changebale: false,
          class: 'textAlignCenter width14_5_wordBreak'
        }
      ];
    },
    /**
     * checkIfBarcode
     * @returns {boolean}
     */
    isBarcode() {
      return this.countType === 'Штрихкод';
    }
  },
  /**
   * BEFORE ROUTE ENTER GUARD
   */
  async beforeRouteEnter(to, from, next) {
    next(async function(vm) {
      if (from.matched[0]) {
        if (from.matched[0].name == 'Warehouse document') {
          await vm.fetchPendingIncomeFromSaleById(vm.$route.params.id);
          vm.checkIfDocIsAccepted();
          vm.get();
          next();
        }
      }
    });
  },
  async created() {
    if (!this.currentPendingIncomeFromSale.id) {
      await this.fetchPendingIncomeFromSaleById(this.$route.params.id);
    }

    this.checkIfDocIsAccepted();
    await this.get();
    this.$barcodeScanner.init(this.onBarcodeScanned);
  },
  destroyed() {
    this.$barcodeScanner.destroy();
  },
  watch: {
    checkAllNotFounds: {
      handler(newValue) {
        if (newValue) {
          this.newItemsToCreate = [];
          let length = this.accepted.length;
          for (let i = 0; i < length; i++) {
            if (this.accepted[i].hasOwnProperty('_rowVariant')) {
              if (this.accepted[i]['_rowVariant'] == 'danger') {
                this.newItemsToCreate.push(this.accepted[i]);
              }
            }
          }
        } else {
          if (this.fromCheckbox) {
            this.newItemsToCreate = [];
          }
        }
      }
    },
    fillAllItems: {
      handler(newValue) {
        if (newValue) {
          let length = this.accepted.length;
          for (let i = 0; i < length; i++) {
            this.accepted[i].currentReceivingCount =
              this.accepted[i].count -
              (this.accepted[i].receiveCount
                ? this.accepted[i].receiveCount
                : 0);
            Vue.set(
              this.accepted[i],
              'currentReceivingCount',
              this.accepted[i].currentReceivingCount
            );
            Vue.set(this.accepted, i, this.accepted[i]);
            Vue.set(this.accepted[i], 'changed', true);
            this.removeCellVariantsFromItem(i);
          }
        } else {
          let length = this.accepted.length;
          for (let i = 0; i < length; i++) {
            if(this.currentPendingItems[i].id == this.accepted[i].id) {
              this.accepted[i].currentReceivingCount = this.currentPendingItems[i].currentReceivingCount
            }else{
               this.accepted[i].currentReceivingCount = null;
            }
            Vue.set(
              this.accepted[i],
              'currentReceivingCount',
              this.accepted[i].currentReceivingCount
            );
            Vue.set(this.accepted, i, this.accepted[i]);
            this.removeCellVariantsFromItem(i);
          }
        }
      }
    },
    accepted: {
      deep: true,
      handler() {
        this.hasShortage = false;
        this.accepted.map((item, i) => {
          if (
            parseFloat(item.currentReceivingCount) !==
              parseFloat(this.originalFilteredItems[i].count) &&
            item.changed
          ) {
            this.hasShortage = true;
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.incomeFromSaleWrapper /deep/ {
	@import '~bootstrapVue2/dist/bootstrap-vue.min';
}
.posCustomModalHeader {
	width: 100%;
}
.b-table-sticky-header {
  margin-bottom: 0.5rem;
}
.w-300 {
  width: 300px;
}
.w-88p {
  width: 88%;
  display: inline-block;
}

.w-10p {
  width: 10%;
  display: inline-block;
  font-size: 16px;
}

.alignCenter {
  text-align: center;
}
.spinner-wrapper {
  position: absolute;
  background: rgba(32, 28, 32, 0.49);
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  padding-top: 35px;
  z-index: 5;
}
#notFoundBarcode {
  color: red;
}
#lastFoundBarcode {
  color: green;
}
.receiveInput {
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
